@if (isSettingUp()) {
  <app-inline-notice title="Kampagne wird eingerichtet" message="Adressen und Analysen werden angelegt. Das dauert einen Moment." />
}
@if (setupFailed()) {
  <app-inline-notice tone="error" title="Einrichtung fehlgeschlagen" [message]="setupError()">
    <p class="mt-2">Bitte wenden Sie sich an den Support, falls das Problem weiterhin besteht.</p>
  </app-inline-notice>
}
@if (campaign()!.creationSummary; as summary) {
  @if (summary.analysesFailed > 0) {
    <app-inline-notice tone="warning" [title]="summary.analysesFailed + ' Adressen konnten nicht verarbeitet werden'">
      @if (summary.existingAddresses !== undefined) {
        <p>{{ summary.analysesCreated }} angelegt · {{ summary.newAddresses }} neu · {{ summary.existingAddresses }} bereits vorhanden</p>
      }
      @for (failure of summary.failures.slice(0, 5); track $index) {
        <p class="mt-1 text-xs">Zeile {{ failure.index + 1 }}: {{ failure.reason }}</p>
      }
    </app-inline-notice>
  }
}
@if (store.error()) { <app-inline-notice tone="error" [message]="store.error()" /> }

<section class="-mt-5 grid grid-cols-2 gap-x-12 border-b border-border lg:grid-cols-4" aria-label="Kennzahlen">
  @for (kpi of kpis(); track kpi.label) {
    <div class="relative flex min-w-0 flex-col gap-1 py-6 lg:before:absolute lg:before:inset-y-0 lg:before:-left-6 lg:before:w-px lg:before:bg-border lg:first:before:hidden" [hlmTooltipTrigger]="kpi.tip">
      <p class="ks-eyebrow">{{ kpi.label }}</p>
      <p class="mt-1.5 flex flex-wrap items-baseline gap-1.5">
        <span class="text-3xl font-bold leading-9 tracking-tight tabular-nums">{{ kpi.value }}</span>
        <span class="text-dense text-muted-foreground">{{ kpi.unit }}</span>
      </p>
      <p class="truncate text-xs text-muted-foreground">{{ kpi.hint }}</p>
    </div>
  }
</section>

<section aria-label="Ablauf">
  <div class="flex min-h-8 flex-wrap items-center gap-3">
    <h2 class="text-base font-bold">Ablauf</h2>
    @if (store.run(); as run) {
      <span class="text-xs text-muted-foreground">{{ run.label }} läuft: {{ run.done | number: '1.0-0' : 'de-DE' }} von {{ run.total | number: '1.0-0' : 'de-DE' }}</span>
      <span class="flex-1"></span>
      <button hlmBtn type="button" variant="outline" size="sm" (click)="store.go('executions')">Berechnung ansehen</button>
    }
  </div>

  <!-- The same step rail as in the execution panel; each step sits exactly on its column below. -->
  <div class="overflow-hidden">
    <app-step-timeline class="-ml-1 -mr-[3.25rem] block" [steps]="steps()" [config]="timelineConfig" />
  </div>

  <div class="mt-1 grid grid-cols-1 gap-x-12 gap-y-4 sm:grid-cols-2 lg:grid-cols-4">
    @for (phase of phases(); track phase.name) {
      <div class="flex min-w-0 flex-col">
        @for (row of phase.rows; track row.stage) {
          <ng-template #tip>
            <span class="flex justify-between gap-6 font-bold"><span>{{ row.meta.label }}</span><span class="font-mono">{{ row.count | number: '1.0-0' : 'de-DE' }}</span></span>
            <span class="block text-white/70">{{ row.share }} der Kampagne</span>
            <span class="mt-1 block">{{ row.meta.tip }}</span>
            @if (row.detail) { <span class="mt-1 block text-white/70">{{ row.detail }}</span> }
          </ng-template>
          <button type="button" class="group -mx-2 flex h-7 items-center gap-2 rounded-md px-2 text-left text-dense transition-colors enabled:hover:bg-muted disabled:pointer-events-none disabled:text-muted-foreground"
            [disabled]="!row.count" [hlmTooltipTrigger]="tip" [showDelay]="600" (click)="openRow(row.stage, row.action)">
            <span class="size-2 shrink-0 rounded-full" [style.background-color]="row.meta.color" aria-hidden="true"></span>
            <span class="truncate">{{ row.meta.label }}</span>
            @if (row.action) {
              <span class="ml-auto inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-xs text-primary opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100">{{ row.action }}<ng-icon name="lucideArrowRight" class="size-3" /></span>
            }
            <span class="shrink-0 font-mono text-xs" [class.ml-auto]="!row.action">{{ row.count | number: '1.0-0' : 'de-DE' }}</span>
          </button>
        }
      </div>
    }
  </div>
</section>

<app-campaign-area />
